import { Box } from "@mui/material";
import BulleFixed from "../../../components/BulleFixed";
import ContactForm from "../../HomePage/Accueil/ContactForm";
import BlocAvantages from "./BlocAvantages";
import BlocBackground from "./BlocBackground";
import BlocDevis from "./BlocDevis";
import BlocFonctions from "./BlocFonctions";
import BlocInfographie from "./BlocInfographie";
import BlocQuiSommesNous from "./BlocQuiSommesNous";
import styles from "./styles";

function Blocs() {
  return (
    <Box sx={styles}>
      {/** Titre */}
      <BlocBackground />
      <BlocQuiSommesNous />
      <BlocDevis />
      <BlocInfographie />
      <BlocFonctions />
      <BlocAvantages />
      <BulleFixed />
      <ContactForm />
    </Box>
  );
}

export default Blocs;
